import { render, staticRenderFns } from "./SubjectDetails.vue?vue&type=template&id=92891eca&"
import script from "./SubjectDetails.vue?vue&type=script&lang=js&"
export * from "./SubjectDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports